export { AddressColumnComponent } from './address-column.component';
